export { default } from './GalleryCard';
